import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons'
import { Anchor, Box, type BoxProps, Flex } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import clsx from 'clsx'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { useStoreCategories } from '../../hooks/useStoreCategories'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import styles from './styles.module.css'

const LIMIT_CATEGORIES_TO_SHOW = 15

export function ListNavigationCategories(props?: BoxProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-product-list',
  })

  const [opened, handlers] = useDisclosure(false)

  const router = useRouter()
  const path = useStorePathBuilder()
  const categories = useStoreCategories()
  const currentCategoryId = `${router.query.categoryId}`
  const diffCountCategories = categories.length - LIMIT_CATEGORIES_TO_SHOW

  return (
    <Box className={styles.categories} {...props}>
      {categories
        .slice(0, opened ? categories.length : LIMIT_CATEGORIES_TO_SHOW)
        .map((c) => {
          const isActive = String(c.id) === String(currentCategoryId)
          const href = path(`categories/${c.id}?category_ids=${c.id}`)

          return (
            <Link
              key={c.id}
              href={href}
              className={clsx(styles.categoryLink, {
                [styles.categoryLinkActive]: isActive,
              })}
            >
              {c.name}
            </Link>
          )
        })}
      {diffCountCategories >= 1 && (
        <Anchor onClick={handlers.toggle} size='sm' ml='xs'>
          <Flex align='center' gap='xs'>
            <Icon icon={opened ? faChevronUp : faChevronDown} size='xs' />
            {opened ? t('label_show_less') : t('label_show_more')}
          </Flex>
        </Anchor>
      )}
    </Box>
  )
}
